<template>
    <div class="news-list uk-grid" uk-grid>
        <div v-for="item in items" class="uk-width-1-2@s uk-width-1-3@m">
          <div class="news-card new-card--horizontal news-card--vertical@s" :class="{ focus: item.focus}" data-uk-rr-grid-item>
            <a class="news-card__link" :href="item.url" :title="item.title">
              <div class="news-card__media-wrapper" v-if="item.featured_media">
                <div class="news-card__media" v-html="item.featured_media.data.thumbnail"></div>
              </div>
              <div class="news-card__body">
                <p class="news-card__label" v-if="item.category">{{item.category.data.present}}</p>
                <p class="news-card__title">{{item.title}}</p>
                <!-- <p v-if="item.abstract" class="news-card__text">{{item.abstract}}</p> -->
                <p class="news-card__date">{{item.published_date}}</p>
              </div>
            </a>
          </div>
        </div>
    </div>
</template>
<script>
  import DataGridResults from 'js/theme-mixins/DataGridResults';

  export default {
    mixins: [DataGridResults],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/museo/extensions/rubinred/collections/assets/js/NewsDataGridResults.vue